<template>
  <v-container fluid>
    <v-layout>
      <v-flex class="margin-custom-width-left">
        <br />
        <v-flex xs12 sm10 md6>
          <v-alert
            :value="true"
            color="info"
            outline
          >Sign-up so you can receive text reminders before sessions and get notified of any cancellations.</v-alert>
          <br />
          <v-form ref="form" v-model="valid">
            <v-text-field
              prepend-icon="person"
              v-model="firstName"
              :rules="firstNameRules"
              label="First Name"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="person_outline"
              v-model="lastName"
              :rules="lastNameRules"
              label="Last Name"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="contact_mail"
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>

            <v-text-field
              prepend-icon="phone"
              v-model="phoneNumber"
              :rules="phoneRules"
              hint="Please ensure accurate phone number is entered. Text message with code will be sent to your phone."
              label="Phone"
              mask="phone"
            ></v-text-field>

            <v-select
              prepend-icon="directions_run"
              :items="ageGroups"
              label="Age Group"
              :rules="ageGroupRules"
              v-model="selectedAgeGroups"
              item-text="ageGroup"
              item-value="id"
              return-object
              hint="Select age group for each participant if you have more than 1 attendee"
              multiple
            ></v-select>

            <v-btn :disabled="!valid" @click="signUp()" color="primary">Sign-up</v-btn>
            <v-btn @click="clear" color="info">Clear</v-btn>
            <br />
            <br />
          </v-form>
        </v-flex>
      </v-flex>
    </v-layout>
    <br />
    <br />
    <v-snackbar
      v-model="toast"
      :color="toastColor"
      :timeout="toastTimeout"
      multi-line
    >{{ toastMessage }}</v-snackbar>
  </v-container>
</template>


<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import dataService from "@/data/data.service";

export default {
  data: () => ({
    lastName: null,
    firstName: null,
    email: null,
    phoneNumber: null,
    optTextAlert: false,
    selectedAgeGroups: null,
    toast: false,
    toastMessage: null,
    toastTimeout: 8000,
    toastColor: "success",
    valid: false,
    firstNameRules: [
      v => !!v || "Name is required",
      v => /^\S+$/.test(v) || "Please enter First name only. No spaces."
    ],
    lastNameRules: [
      v => !!v || "Name is required",
      v => /^\S+$/.test(v) || "Please enter Last name only. No spaces."
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    phoneRules: [v => !!v || "Phone is required"],
    ageGroupRules: [v => !!v || "Age Group is required"]
  }),
  mounted() {
    this.getAgeGroups();
  },

  methods: {
    clear() {
      this.$refs.form.reset();
    },
    signUp() {
      //check if account already exists
      //TERRIBLE CODE, NEEDS TO BETTER.

      let eParams = { userId: this.email };

      this.getAccount(eParams).then(() => {
        if (this.account.length !== 0) {
          this.toastMessage =
            "Email already exists in system. Go to login to sign up or request a new key.";
          this.toastColor = "error";
          this.toast = true;
        } else {
          let pParams = { phoneNumber: this.phoneNumber };
          this.getAccount(pParams).then(() => {
            if (this.account.length !== 0) {
              this.toastMessage =
                "Phone number already exists in system. Enter a different number or go to login to sign-up with this account.";
              this.toastColor = "error";
              this.toast = true;
            } else {
              let account = {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phoneNumber: this.phoneNumber,
                optTextAlert: 1,
                userRole: "USER",
                secretKey: dataService.modules.secrets.getRandomKey()
              };
              this.createAccount(account).then(accountId => {
                this.selectedAgeGroups.forEach(f => {
                  this.addAccountAge({
                    ageGroupId: f.id,
                    accountId: accountId
                  });
                });
                this.toastMessage =
                  "Thanks for signing up. You will receive text messages as reminders before pickup session so you can register.";
                this.toastColor = "success";
                this.toast = true;
              });
            }
          });
        }
      });
    },

    textKey(phone, secretKey) {
      let smsObj = {
        Message: `Here is your secret key: ${secretKey}`,
        MessageStructure: "string",
        PhoneNumber: `+1${phone}`
      };
      dataService.modules.sms.sendTextMessage(smsObj);
    },

    pinpointKey(phone, secretKey) {
      var messageType = "TRANSACTIONAL";
      var applicationId = "f5eaf7ea3af04928a8fddc0ece0beb9a";
      var destinationNumber = `1${phone}`;
      var message = `Here is your secret key: ${secretKey}`;

      let smsObj = {
        ApplicationId: applicationId,
        MessageRequest: {
          Addresses: {
            [destinationNumber]: {
              ChannelType: "SMS"
            }
          },
          MessageConfiguration: {
            SMSMessage: {
              Body: message,
              MessageType: messageType
            }
          }
        }
      };
      dataService.modules.pinpoint.sendTextMessage(smsObj);
    },

    emailKey(name, email, secretkey) {
      let env = process.env.NODE_ENV || "development";
      let config = require("../../config")[env];
      let emailObj = {
        from: "no-reply@fairfaxcityfutsal.com",
        to: email,
        subject: "Welcome to Fairfax City Futsal!",
        body: `Hi ${name}, <br><br>
               Here is your key to login: ${secretkey}
               <br><br>Once signed-in, you can sign-up for sessions. 
               If you have any questions, please email at fairfaxcityfutsal@gmail.com
               <br><br><a href="https://www.fairfaxcityfutsal.com">Fairfax City Futsal</a>
              `
      };
      dataService.modules.email.sendMail(emailObj);
    },

    ...mapActions("account", {
      getAccount: "get",
      createAccount: "add"
    }),

    ...mapActions("accountAge", {
      addAccountAge: "add"
    }),
    ...mapActions("ageGroup", { getAgeGroups: "get" })
  },

  computed: {
    ...mapGetters("account", ["account"]),
    ...mapGetters("ageGroup", ["ageGroups"])
  }
};
</script>